<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.tags')" :newButShow="true" @newBut="newBut('add')"></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ baseMtag_name: true }" />
        <myTable ref="table" :columns="columns" requestUrl="base-mtag/list" :showPage="true">
          <template v-slot:action="{ data }">
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="newBut('edit',data.row)"
            />
            <Icon
              class="cursor_p mg-left15"
              @click="handleToDetail(data.row)"
              type="ios-eye"
              size="26"
              color="#7D7C7F"
            />
          </template>
          <template v-slot:multiple="{ data }">
            <span>{{data.row.multiple == 0?$t("no"):$t("yes")}}</span>
          </template>
        </myTable>
      </div>
    </div>
    <edit v-if="modal" @onOk="onOk" :type="type" :modal="modal" :itemObj="itemObj" @cancel="cancel"></edit>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
import myTableFilter from "@/components/myTableFilter";
import edit from "./module/baseMtag_edit";
export default {
  name: "baseMtag",
  components: {
    myTable,
    pageTitle,
    myTableFilter,
    edit
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          key: "cat_id",
          align: "center",
          width: 100,
        },
        {
          title: this.$t("Tags.name") + "(EN)",
          key: "en_cname",
          align: "center"
        },
        {
          title: this.$t("Tags.name") + "(繁体)",
          key: "zh-tw_cname",
          align: "center"
        },
        {
          title: this.$t("Tags.name") + "(简体)",
          key: "zh-cn_cname",
          align: "center"
        },
        {
          title: this.$t("Tags.wi"),
          key: "score",
          align: "center"
        },
        {
          title: this.$t("multiples"),
          slot: "multiple",
          align: "center"
        },
        {
          title: this.$t("home.school"),
          key: "status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.school == 1
              },
              on: {
                'on-change': value => {
                  //   if (value == false) {
                  //     var op = 0;
                  //   } else {
                  //     var op = 1;
                  //   }
                  this.setStatus2(params.row.cat_id,"school");
                }
              }
            });
          }
        },
        {
          title: this.$t("Teaching_Staff"),
          key: "status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.teacher == 1
              },
              on: {
                'on-change': value => {
                  //   if (value == false) {
                  //     var op = 0;
                  //   } else {
                  //     var op = 1;
                  //   }
                  this.setStatus2(params.row.cat_id,"teacher");
                }
              }
            });
          }
        },
        {
          title: this.$t("Non_Teaching_Staff"),
          key: "status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.staff == 1
              },
              on: {
                'on-change': value => {
                  //   if (value == false) {
                  //     var op = 0;
                  //   } else {
                  //     var op = 1;
                  //   }
                  this.setStatus2(params.row.cat_id,"staff");
                }
              }
            });
          }
        },
        {
          title: this.$t("status"),
          key: "status",
          align: "center",
          render: (h, params) => {
            //return h('元素',{元素的性质},'内容')
            return h('i-switch', {
              props: {
                size: 'large',
                value: params.row.status == 1
              },
              on: {
                'on-change': value => {
                  //   if (value == false) {
                  //     var op = 0;
                  //   } else {
                  //     var op = 1;
                  //   }
                  this.setStatus(params.row.cat_id);
                }
              }
            });
          }
        },
        {
          title: this.$t("Info.order"),
          key: "sort_id",
          align: "center"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action",
          width: 180,
        },
      ],
      modal: false,
      itemObj: {},
      type: "add"
    };
  },
  created () {
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    newBut (type, item) {
      this.type = type
      this.itemObj = item
      this.modal = true
    },
    cancel () {
      this.modal = false
    },
    onOk () {
      this.$base.msgSuccess(this.$t("op_ok"));
      this.$refs.table.getLoad();
    },
    handleToDetail (item) {
      this.$base.linkTo("/edu/baseMtag_item", { id: item.cat_id });
    },
    setStatus2 (cat_id,type) {
      this.$base.showLoading();
      this.$request.sendPost(
        'base-mtag/upd_roles',
        { cat_id: cat_id ,role:type},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.onOk()
        }
      );
    },
    setStatus (cat_id) {
      this.$base.showLoading();
      this.$request.sendPost(
        'base-mtag/upd_status',
        { cat_id: cat_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.onOk()
        }
      );
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/baseMtag/baseMtag.vue